import React, { FC, useState } from "react";
import {
   Box,
   Button,
   Checkbox,
   Divider,
   Flex,
   FormControl,
   FormLabel,
   IconButton,
   Input,
   Modal,
   ModalBody,
   ModalCloseButton,
   ModalContent,
   ModalFooter,
   ModalHeader,
   ModalOverlay,
   Stack,
   Text,
   useDisclosure,
   useToast,
} from "@chakra-ui/react";
import { AiFillEdit } from "react-icons/ai";
import axios from "axios";
import { IType } from "../../ts/interfaces/announces_interface";
import { HuePicker, TwitterPicker } from "react-color";
import { FieldEdit, FieldForm } from "./FirewallTypeField";

interface EditTypeProps {
   type: IType;
   onEdit: () => void;
}

export const EditFirewallType: FC<EditTypeProps> = ({ type, onEdit }) => {
   const initForm = {
      name: type.name,
      cmd: type.cmd,
      remove_cmd: type.remove_cmd,
      color: type.color,
      need_port: type.need_port,
      fields: type.fields || [],
   };
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [form, setForm] = useState(initForm);

   const [load, setLoad] = useState(false);
   const toast = useToast();

   return (
      <>
         <IconButton
            aria-label={"icon"}
            icon={<AiFillEdit />}
            onClick={() => {
               setForm(initForm);
               setLoad(false);
               onOpen();
            }}
            colorScheme="warning"
         />
         <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="2xl"
            scrollBehavior="inside"
         >
            <ModalOverlay />
            <ModalContent>
               <ModalHeader>Firewall Type</ModalHeader>
               <ModalCloseButton />
               <ModalBody>
                  <Stack spacing="3">
                     <FormControl>
                        <FormLabel>Name</FormLabel>
                        <Input
                           placeholder="Name"
                           value={form.name}
                           isDisabled={load}
                           onChange={(e) =>
                              setForm({ ...form, name: e.target.value })
                           }
                        />
                     </FormControl>
                     <FormControl>
                        <FormLabel>Cmd</FormLabel>
                        <Input
                           placeholder="Cmd"
                           value={form.cmd}
                           isDisabled={load}
                           onChange={(e) =>
                              setForm({ ...form, cmd: e.target.value })
                           }
                        />
                     </FormControl>
                     <FormControl>
                        <FormLabel>Remove cmd</FormLabel>
                        <Input
                           placeholder="Remove cmd"
                           value={form.remove_cmd}
                           isDisabled={load}
                           onChange={(e) =>
                              setForm({ ...form, remove_cmd: e.target.value })
                           }
                        />
                     </FormControl>
                     <HuePicker
                        width={"100%"}
                        color={form.color}
                        onChange={(color) =>
                           setForm({ ...form, color: color.hex })
                        }
                     />
                     <TwitterPicker
                        width={"100%"}
                        color={form.color}
                        onChange={(color) =>
                           setForm({ ...form, color: color.hex })
                        }
                     />
                     <Checkbox
                        isChecked={form.need_port}
                        onChange={(e) =>
                           setForm({ ...form, need_port: e.target.checked })
                        }
                     >
                        Need port
                     </Checkbox>
                     <Flex align="center">
                        <Divider />
                        <Text padding="2">Fields</Text>
                        <Divider />
                     </Flex>
                     <Box>
                        <Stack spacing={3} divider={<Divider />}>
                           {form.fields?.map((field, idx) => (
                              <FieldEdit
                                 field={field}
                                 onDelete={() => {
                                    let newFields = [...form.fields];
                                    newFields.splice(idx, 1);
                                    console.log(newFields);
                                    setForm({ ...form, fields: newFields });
                                 }}
                                 onUpdate={(field) => {
                                    let newFields = [...form.fields];
                                    newFields[idx] = field;
                                    setForm({ ...form, fields: newFields });
                                 }}
                              />
                           ))}
                           <FieldForm
                              onAdd={(field) => {
                                 setForm({
                                    ...form,
                                    fields: [...form.fields, field],
                                 });
                              }}
                           />
                        </Stack>
                     </Box>
                  </Stack>
               </ModalBody>

               <ModalFooter>
                  <Button
                     colorScheme="brand"
                     mr={3}
                     isDisabled={load}
                     isLoading={load}
                     onClick={() => {
                        setLoad(true);
                        axios
                           .patch(`/admin/announces/types/${type.id}`, form)
                           .then(() => {
                              setLoad(false);
                              toast({
                                 title: `Commit success`,
                                 position: "top",
                                 status: "success",
                                 isClosable: true,
                              });
                              onEdit();
                           })
                           .catch((error) => {
                              let res = error.response;
                              if (res) {
                                 toast({
                                    title: res.data.message,
                                    status: "error",
                                    position: "top",
                                    isClosable: true,
                                 });
                              }
                           })
                           .finally(() => onClose());
                     }}
                  >
                     Save
                  </Button>
                  <Button onClick={onClose} isDisabled={load}>
                     Cancel
                  </Button>
               </ModalFooter>
            </ModalContent>
         </Modal>
      </>
   );
};
